export const downloadBlobXlsx = (data: BlobPart | Blob, fileName: string) => {
  const link = document.createElement('a');
  document.body.appendChild(link);
  link.setAttribute('style', 'display: none');

  const blob = data instanceof Blob ? data : new Blob([data], { type: 'application/octet-stream' });
  const url = window.URL.createObjectURL(blob);

  link.href = url;
  link.download = fileName;
  link.click();
  window.URL.revokeObjectURL(url);
  link.remove();
};

export const buildReportFileName = (period: string[]): string => {
  return `Отчет по тестам ${period.join(' - ')}.xlsx`;
};